import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider } from '@mui/material';

const SectorulCulturalTineretEditorial: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Cultural, de Tineret și Editorial
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Departamente
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Departamentul Cultural" 
                secondary="Responsabil pentru activitățile culturale"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Departamentul de Tineret" 
                secondary="Responsabil pentru activitățile cu tinerii"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Departamentul Editorial" 
                secondary="Responsabil pentru publicații și materiale editoriale"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectorulCulturalTineretEditorial;
